import React from "react";
import PropTypes from "prop-types";
import { ProgressContainer, ProgressBar } from "./styles"; // adjust path
import { commaSeperator } from "../../utils/methods";

const MonthlyGoalProgress = ({ item }) => {
  const dailySteps =
    item?.challenge_participants?.challenge_level?.daily_goal_steps || 0;

  const monthlyTarget =
    item?.challenge_participants?.challenge_level?.monthly_target_steps || 0;

  const activityType =
    item?.challenge_participants?.challenge_level?.activity_type || "steps";

  // If data is missing, render nothing
  if (!monthlyTarget) return null;

  const progressPercentage = Math.min(
    Math.round((dailySteps / monthlyTarget) * 100),
    100
  );

  return (
    <>
      <ProgressContainer isFontSize="16px">
        <div className="progressText">
          Progress -
          <span className="value">
            {commaSeperator(dailySteps)} {activityType}
          </span>
        </div>

        <div className="progressText">
          Monthly Target -
          <span className="value">
            {commaSeperator(monthlyTarget)} {activityType}
          </span>
        </div>
      </ProgressContainer>

      <ProgressBar progress={`${progressPercentage}%`} isColor={activityType == "steps" ? "#DA6C74" : activityType == "miles" ? "#DA9B6C" : "#75B084" }>
        <div
          className="barWidth"
          style={{ width: `${progressPercentage}%` }}
        />
      </ProgressBar>
    </>
  );
};

MonthlyGoalProgress.propTypes = {
  item: PropTypes.object.isRequired,
};

export default MonthlyGoalProgress;
